import { createFileRoute } from "@tanstack/react-router";

import Integrations from "@/containers/Integrations";

export const Route = createFileRoute("/_app/(account)/integrations")({
  component: () => <Integrations />,
});
